export default {
  bulkUploadUser: {
    method: "post",
    url: "/agent/v1/dashboard/bulk-register",
  },
};
